import { useTranslations } from "next-intl";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
import CloseIcon from "@/components/_icons/closeIcon";
import CryIcon from "@/components/_icons/cryIcon";
import { ConfirmButton } from "../button/confirmButton";
import { TextButton } from "../button/textButton";
import { ScheduledTime } from "@/dto/scheduledTime";
import {
  getFromSessionStorage,
  saveToSessionStorage,
} from "@/utils/sessionStorageUtils";
import { Service } from "@/dto/service";
import { SessionStorageKey } from "@/utils/storageKeys";
import { RegularModal } from "../modals/modals";
import { OrderType } from "@/types";

export const DeliveryModalError = ({
  isOpen,
  onRequestClose,
  merchantColor,
  merchant,
  address,
  onEnterNewAddress,
  checkoutCloseHandler,
}: any) => {
  const t = useTranslations("DeliveryModalError");
  const switchToPickup = () => {
    const sessionTime = getFromSessionStorage<Partial<ScheduledTime>>(
      SessionStorageKey.SCHEDULED_TIME,
      {}
    );
    const merchantService = merchant?.services.find(
      (s: Service) => s.type === "PICKUP" || s.type === "WEBSITE"
    );
    const deliveryService = merchant?.services.find(
      (s: Service) => s.type === "DELIVERY"
    );
    let enabledDefaultOrderType = "";
    const retailServices = [
      { type: OrderType.PICKUP, service: merchantService },
      { type: OrderType.DELIVERY, service: deliveryService },
    ];
    const enabledServices = retailServices.filter(
      ({ service }) => service?.enabled
    );

    if (enabledServices.length >= 1) {
      enabledDefaultOrderType = enabledServices[0].type;
    }
    saveToSessionStorage(SessionStorageKey.SCHEDULED_TIME, {
      orderType: merchant?.isRetail
        ? enabledDefaultOrderType
        : OrderType.PICKUP,
      date: sessionTime?.date || null,
      time: sessionTime?.time || null,
    });

    if (merchant?.isRetail) {
      window.dispatchEvent(
        new StorageEvent("storage", { key: "pickup-order-type" })
      );
    } else if (merchant?.isRestaurant) {
      window.dispatchEvent(
        new StorageEvent("storage", { key: "pickup-order-type" })
      );
    }
    checkoutCloseHandler();
    onRequestClose && onRequestClose();
  };
  return (
    <RegularModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="bg-opacity-50"
    >
      <div className="bg-white sm:rounded-lg shadow-lg w-[100%] h-[100%] sm:h-[auto] sm:w-[70%] mx-auto overflow-hidden">
        <div className="flex justify-between items-center px-6 pt-6">
          <button
            onClick={switchToPickup}
            className="text-gray-600 hover:text-gray-900 ml-auto"
            data-testid={applyDataTestId(pom.modals.closeButton)}
          >
            <CloseIcon />
          </button>
        </div>
        <div className="px-4 pb-4 flex flex-col justify-center items-center">
          <CryIcon brandingColor={merchantColor} />
          <p className="mt-4 text-3xl font-medium text-center text-[#373737] text-[32px]">
            {t("title")}
          </p>
          <p className="mt-4 text-base leading-6 text-center text-[15px] text-neutral-700 w-full">
            {t("cannotDeliver", { merchantName: merchant.name })}
          </p>
          <p className="text-base font-bold leading-6 text-center text-[15px] text-neutral-700 w-full">
            {address.address1}, {address.city}, {address.state}, {address.zip}
          </p>
          <p className="mt-4 text-base leading-6 text-center text-[15px] text-neutral-700 w-full">
            {t("chooseDifferentAddress")}
          </p>
          <ConfirmButton
            onClick={switchToPickup}
            style={{ backgroundColor: merchantColor }}
            className="px-16 py-4 mt-24 max-w-full text-xl font-medium leading-7 text-center text-white whitespace-nowrap bg-[#228800] disabled:bg-[#C7C7C7] rounded-lg w-[250px] max-md:px-5 max-md:mt-10"
          >
            <p>{t("switchToPickup")}</p>
          </ConfirmButton>
          <TextButton
            onClick={onEnterNewAddress}
            style={{ color: merchantColor }}
          >
            <p>{t("enterNewAddress")}</p>
          </TextButton>
        </div>
      </div>
    </RegularModal>
  );
};
